<style scoped>
.Paragraph {
  font-size: 16px;
  line-height: 28px;
  color: #000000;
}
</style>

<template>
  <div class="Paragraph" :class="class_root">
    <Animation>
      <slot></slot>
    </Animation>
  </div>
</template>

<script>

// -----

import {eventService} from "../../service/eventService";

export default {
  props: {},
  data() {
    return {
      state: {},
      events: []
    }
  },
  computed: {
    class_root() {
      const classes = []
      return classes
    }
  },
  beforeMount() {
    for (const event of this.events) {
      eventService.register(event)
    }
  },
  mounted() {
  },
  beforeDestroy() {
    for (const event of this.events) {
      eventService.unregister(event)
    }
  },
  methods: {}
}
</script>
